import RandingStyle11 from "../../randing/RandingStyle11";

function Randing031({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "a27aa18a-2877-4757-b875-160e4eb8aad7", label: "일반치료" },
    { value: "4185c549-c636-4fb4-b787-1e6c2baa37fe", label: "치아교정" },
    { value: "be0244bd-ec2f-45bb-83e0-d82ae746381c", label: "임플란트" },
  ];
  return (
    <RandingStyle11
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_03.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_06.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_07.jpg`}
      img7Path={`${process.env.REACT_APP_CDN_BASE}/images/031/01_241217_08.jpg`}
      videoUrl={"https://www.youtube.com/embed/DTYAl2wb_Oc"}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton.png`}
      companyName="의정부아이엠치과"
      callNumber={"tel:1577-7371"}
      kakaoLink={"https://pf.kakao.com/_VxnbxmK"}
      isCallInsideContactBox={true}
      isKakaoInsideContactBox={true}
      isFixedCallIcon={true}
      isFixedKakaoIcon={true}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/uijeongbu.jpg`}
      articleOption={true}
      treatments={treatments}
      adTarget="맘카페 이용자"
    />
  );
}

export default Randing031;
